import React, { useState, useEffect } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { MapPin, ChevronRight, ChevronLeft } from "react-feather";
import useWindowSize from "utils/useWindowSize";
import { useTheme, Typography, Box } from "@mui/material";
import Image from "next/image";

const Slider = ({ linkData, interval = 3000 }) => {
  const { sizes } = useWindowSize();
  const theme = useTheme();

  const [activeIndex, setActiveIndex] = useState(0);

  const handleChangeSlide = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    if (linkData.length > 0) {
      // Prevent running if no data is available

      const timer = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % linkData.length);
      }, interval);

      // Clear the interval when the component is unmounted or when `interval` or `linkData.length` changes
      return () => clearInterval(timer);
    }
  }, [linkData.length, interval]);

  const CustomNextButton = ({ onClick }) => (
    <button
      onClick={onClick}
      className="flex justify-center items-center -mt-10 absolute bg-primary-900 right-0 top-1/2 w-10 h-20 cursor-pointer transition-colors duration-200 hover:bg-primary-700"
    >
      <ChevronRight color="white" size={28} />
    </button>
  );

  const CustomPrevButton = ({ onClick }) => (
    <button
      onClick={onClick}
      className="flex justify-center items-center -mt-10 absolute bg-primary-900 left-0 top-1/2 w-10 h-20 cursor-pointer transition-colors duration-200 hover:bg-primary-700 z-1"
    >
      <ChevronLeft color="white" size={28} />
    </button>
  );

  const CustomIndicators = ({ cIndex, total }) => {
    return (
      <div
        className="absolute bottom-6 left-1/2 flex flex-row"
        style={{ marginLeft: -1 * total * 14 }}
      >
        {Array.from({ length: total }).map((_, index) => (
          <div
            key={index}
            className="h-2.5 bg-secondary rounded-full mx-1"
            style={{
              backgroundColor:
                cIndex === index ? theme.palette.secondary : "#ffffff54",
              width: cIndex === index ? 39 : 10,
            }}
          ></div>
        ))}
      </div>
    );
  };

  return (
    <div
      className="relative"
      style={
        {
          // height: sizes.sm ? 439 : 639,
        }
      }
    >
      <Carousel
        showThumbs={false}
        showStatus={false}
        showIndicators={false}
        infiniteLoop
        // autoPlay
        interval={interval}
        // className="relative"
        // onChange={(index) => setCurrentIndex(index)}

        selectedItem={activeIndex}
        onChange={handleChangeSlide}
        renderArrowNext={(onClickHandler) => (
          <CustomNextButton onClick={onClickHandler} />
        )}
        renderArrowPrev={(onClickHandler) => (
          <CustomPrevButton onClick={onClickHandler} />
        )}
      >
        {linkData &&
          linkData.length > 0 &&
          linkData.map((item) => (
            <div key={item.id}>
              <div>
                <Image
                  width={530}
                  height={0}
                  src={item.image.path}
                  layout="responsive"
                  priority
                  alt="Business Registration"
                  // className="object-contain h-full w-full"
                  className={
                    sizes === "sm" ? "mt-[60px]" : "mt-[80px] max-h-[550px] "
                  }
                />
                <Box className="h-[4px] w-full bg-[#303982]"></Box>
              </div>
            </div>
          ))}
      </Carousel>

      {linkData && linkData.length > 0 && (
        <CustomIndicators cIndex={activeIndex} total={linkData.length} />
      )}
    </div>
  );
};

export default Slider;
